import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import Shoot from "./shoot"
import { logUserAction } from "../../Utils/analytics"

const FullScan = () => {

    const [isToothPicker, setToothPicker] = useState(true)
    const [activeImageSide, setImageSide] = useState(0)
    const navigate = useNavigate()

    const uid = JSON.parse(localStorage.getItem("usertpi") || "{}").usertpi


    useEffect(() => {
        const checkUserAndLog = async () => {
            if (!uid || localStorage.getItem("imageName")) {
                navigate('/')
            } else {
                try {
                    await logUserAction("User entered Full Scan page", uid);
                } catch (error) {
                    console.error('Error logging full scan entry:', error);
                }
            }
        }
        checkUserAndLog();
    }, [navigate])
   
    return (
        <div className="h-full">
            {
                // isToothPicker ?
                    // <ToothSelector setImageSide={setImageSide} setToothPicker={setToothPicker} /> :
                    <Shoot activeImageSide={activeImageSide} setToothPicker={setToothPicker} quickScan={false} setImageSide={setImageSide} />
            }
        </div>
    )
}

export default FullScan